module.exports = require("chart.js");